document.addEventListener("DOMContentLoaded", function () {

  const popup = document.getElementById("sales-popup");
  const img = document.getElementById("popup-image");
  const customer = document.getElementById("popup-customer");
  const product = document.getElementById("popup-product");
  const price = document.getElementById("popup-price");
  const city = document.getElementById("popup-city");
  const time = document.getElementById("popup-time");
  const close = document.querySelector(".sales-popup-close");

  const customers = [
    "Ali Khan", "Ayesha Ahmed", "Bilal Hussain", "Zubair",
    "Hassan Raza", "Faizan", "Usman", "Ahmed", "Hamza", "Faisal"
  ];

  const cities = [
    "Lahore", "Karachi", "Islamabad", "Rawalpindi",
    "Multan", "Faisalabad", "Sialkot", "Gujranwala"
  ];

  const minutes = [
    "2 minutes ago", "5 minutes ago", "8 minutes ago",
    "12 minutes ago", "20 minutes ago", "35 minutes ago",
    "52 minutes ago", "33 minutes ago", "1 hour ago"
  ];

  function random(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function formatPrice(cents) {
    return "Rs. " + (cents / 100).toLocaleString("en-PK");
  }

  function showPopup(products) {
    if (!products || products.length === 0) return;
    const p = random(products);
    customer.innerHTML = random(customers);
    product.innerHTML = p.title;
    price.innerHTML = formatPrice(p.price);
    city.innerHTML = random(cities);
    time.innerHTML = random(minutes);
    img.src = p.image;
    img.alt = p.title;
    popup.classList.add("show");

    setTimeout(function () {
      popup.classList.remove("show");
    }, 6000);
  }

  // Fetch all products live from Shopify
  fetch("/products.json?limit=50")
    .then(res => res.json())
    .then(function (data) {
      const products = data.products.map(function (p) {
        return {
          title: p.title,
          price: p.variants[0].price * 100,
          image: p.images[0] ? p.images[0].src : ""
        };
      });

      setTimeout(function () { showPopup(products); }, 4000);
      setInterval(function () { showPopup(products); }, 18000);
    });

  close.addEventListener("click", function () {
    popup.classList.remove("show");
  });

});
